import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form, Alert, Table } from "react-bootstrap";
import Center from "react-center";
import Select from "react-select";
import * as Icons from "react-feather";
import moment from "moment";
import Axios from "axios";
import { urlAPI } from "Common";
import CanvasStep1 from "./CanvasFilter";
import TableSmall from "./component/TableSmall";
import TableLarge from "./component/TableLarge";

const initDataDokter = {
  count: 0,
  rows: [],
};
export default function JadwalSection(props) {
  const {
    filterJadwal,
    setFilterJadwal,
    selectorSBU,
    selectorUnit,
    loadingUnit,
    setLoadingUnit,
    setMessageState,
    setShowFailed,
    setShowInfo,
    selectedSBU,
  } = props;

  const [dataDokter, setDataDokter] = useState(initDataDokter);
  const [loadingLoad, setLoadingLoad] = useState(false);

  const [openCanvas, setOpenCanvas] = useState(false);

  const fetchJadwalDokter = () => {
    Axios.get(
      urlAPI +
        "/public/jadwaldokter/publicjadwal?params=" +
        JSON.stringify({
          sbu: filterJadwal?.sbu,
          poli: filterJadwal?.poli,
        })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          const minggu = response?.data?.result?.rows?.filter(
            (filter) => filter?.hari === "-" || Number(filter?.hari) === 0
          );
          const senin = response?.data?.result?.rows?.filter(
            (filter) => filter?.hari === "-" || Number(filter?.hari) === 1
          );
          const selasa = response?.data?.result?.rows?.filter(
            (filter) => filter?.hari === "-" || Number(filter?.hari) === 2
          );
          const rabu = response?.data?.result?.rows?.filter(
            (filter) => filter?.hari === "-" || Number(filter?.hari) === 3
          );
          const kamis = response?.data?.result?.rows?.filter(
            (filter) => filter?.hari === "-" || Number(filter?.hari) === 4
          );
          const jumat = response?.data?.result?.rows?.filter(
            (filter) => filter?.hari === "-" || Number(filter?.hari) === 5
          );
          const sabtu = response?.data?.result?.rows?.filter(
            (filter) => filter?.hari === "-" || Number(filter?.hari) === 6
          );
          setDataDokter({
            count: Number(response?.data?.result?.count),
            rows: [minggu, senin, selasa, rabu, kamis, jumat, sabtu],
          });
          setLoadingLoad(false);
        } else {
          setDataDokter(initDataDokter);
          setLoadingLoad(false);
        }
      })
      .catch((err) => {
        const message = err?.response?.message ?? err?.response?.data?.message;
        setMessageState(message);
        if (message === "No Data...") {
          setShowFailed(true);
        } else {
          setShowInfo(true);
        }
        setDataDokter(initDataDokter);
        setLoadingLoad(false);
      });
  };

  const fetchSelectorUnit = (sbu) => {
    return Axios.get(`${urlAPI}/public/unit?sbu=${sbu}`)
      .then((response) => {
        return response.data.result || [];
      })
      .catch((error) => {
        console.error("Error fetching units:", error);
        return [];
      });
  };
  
  /*eslint-disable */
  useEffect(() => {
    if (filterJadwal?.sbu !== null && filterJadwal?.poli !== null) {
      setLoadingLoad(true);
      fetchJadwalDokter();
    }
  }, []);

  useEffect(() => {
    if (selectedSBU) {
      setLoadingUnit(true);
      fetchSelectorUnit(selectedSBU).then((unit) => {
        setFilterJadwal({
          ...filterJadwal,
          sbu: selectedSBU,
          poli: unit.length > 0 ? unit[0].value : null,
          namapoli: unit.length > 0 ? unit[0].label : null,
        });
        setLoadingUnit(false);
      });
    }
  }, [selectedSBU]);
  /*eslint-enable */

  // console.log("data: ", dataDokter);

  return (
    <>
      <h5 style={{ textAlign: "center" }}>
        <strong>
          JADWAL DOKTER
          {filterJadwal?.poli !== null && " " + filterJadwal?.namapoli}
        </strong>
      </h5>
      <br />
      <div className="d-grid gap-2 d-block d-md-none">
        <Button
          block
          variant="warning"
          disabled={loadingLoad}
          onClick={() => {
            setOpenCanvas(true);
          }}
        >
          {loadingLoad ? "Loading..." : " Pilih Poli"}
        </Button>
      </div>
      <Card className="d-none d-md-block">
        <Card.Body>
          <Form>
            <Row>
              <Col lg="4" md="6">
                <Form.Group className="mb-3">
                  <Form.Label>Rumah Sakit / Klinik Tujuan</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="sbu"
                    name="sbu"
                    options={selectorSBU}
                    isDisabled={loadingLoad}
                    value={selectorSBU.find(
                      (find) => find?.value === filterJadwal?.sbu
                    )}
                    onChange={(e) => {
                      setLoadingUnit(true);
                      fetchSelectorUnit(e.value).then((units) => {
                        setFilterJadwal({
                          ...filterJadwal,
                          sbu: e.value,
                          poli: units.length > 0 ? units[0].value : null,
                          namapoli: units.length > 0 ? units[0].label : null,
                        });
                        setLoadingUnit(false);
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col lg="4" md="6">
                <Form.Group className="mb-3">
                  <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
                  {filterJadwal?.sbu !== null ? (
                    <Select
                      styles={{
                        color: "black",
                      }}
                      id="poli"
                      name="poli"
                      options={selectorUnit}
                      isDisabled={loadingLoad}
                      isLoading={loadingUnit}
                      value={selectorUnit.find(
                        (find) => find?.value === filterJadwal?.poli
                      )}
                      onChange={(e) => {
                        setFilterJadwal({
                          ...filterJadwal,
                          poli: e.value,
                          namapoli: e.name,
                        });
                      }}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      value="Pilih Rumah Sakit / Klinik Tujuan Terlebih Dahulu..."
                      disabled
                    />
                  )}
                </Form.Group>
              </Col>
              <Col lg="4" md="12">
                <div className="d-grid gap-2" style={{ paddingTop: "32px" }}>
                  <Button
                    block
                    style={{
                      background: "linear-gradient(135deg, #56ab2f, #a8e063)",
                      border: "none",
                      color: "#fff",
                    }}
                    disabled={
                      filterJadwal?.sbu === null ||
                      filterJadwal?.poli === null ||
                      loadingLoad
                    }
                    onClick={() => {
                      setLoadingLoad(true);
                      fetchJadwalDokter();
                    }}
                  >
                    {loadingLoad ? "Loading..." : "Cari"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      {loadingLoad ? (
        <>
          <br />
          <Center>
            <h3>Loading...</h3>
          </Center>
        </>
      ) : filterJadwal?.poli === null ? (
        <>
          <br />
          <Center>
            <img src="assets/img/medic-2.svg" width="30%" alt="gambar" />
          </Center>
          <br />
          <p style={{ textAlign: "center" }}>
            Mohon Pilih Poli Terlebih Dahulu...
          </p>
        </>
      ) : (
        <>
          {dataDokter?.count > 0 ? (
            <>
              <br />
              <div className="d-block d-lg-none">
                <TableSmall dataDokter={dataDokter} />
              </div>
              <div className="d-none d-lg-block">
                <TableLarge dataDokter={dataDokter} />
              </div>
            </>
          ) : (
            <>
              <br />
              <Center>
                <img src="assets/img/empty-1.svg" width="30%" alt="gambar" />
              </Center>
              <br />
              <p style={{ textAlign: "center" }}>
                Tidak ada Dokter yang Tersedia, Mohon Mencoba Ditanggal yang
                Lain...
              </p>
            </>
          )}
        </>
      )}
      <CanvasStep1
        filterJadwal={filterJadwal}
        setFilterJadwal={setFilterJadwal}
        selectorSBU={selectorSBU}
        fetchSelectorUnit={fetchSelectorUnit}
        selectorUnit={selectorUnit}
        loadingUnit={loadingUnit}
        openCanvas={openCanvas}
        setOpenCanvas={setOpenCanvas}
        fetchJadwalDokter={fetchJadwalDokter}
        setLoadingLoad={setLoadingLoad}
      />
    </>
  );
}
